const navigation = 
[
	
 	{
 		"navTitle": "Home",
 		"coordinates": [-73.96721951876916 , 40.7366044999703],
 		"jumpToZoom": [13.36],
 		"jumpToZoomMobile": [13],
 		"content":[],
 		"mobile": false,
 		"mobileCoordinates": [-73.95391576151086 , 40.73705974646333],
 		"mobileProgression": "Work",
 		"locationContent": {
 			"copy": "<p>Cross platform front-end developer living in Greenpoint, Brooklyn. Learning by creating. How-to video enthusiast. Interested in building novel interactive experiences.</p>",
 			"mobileCopy": "<p>Cross platform front-end developer living in Greenpoint, Brooklyn. Learning by creating. How-to video enthusiast. Interested in building novel interactive experiences.</p>"
 		}


 		
 	},
 	{
 		"navTitle": "Work",
 		"coordinates":[-74.00657056551574 , 40.70479681101878],
 		"mobileCoordinates": [-74.00610373762629 , 40.70468413410646],
 		"jumpToZoom": [18],
 		"jumpToZoomMobile": [16.5],
 		"activateOverlay": true,
 		"mobileProgression": "Home",
 		"locationContent": {
 			"copy": "<p>Chase and Dixie are some of the clients I worked with in my year and a half working at Droga5. Download resume <a class='resume' href='#'>here</a>.</p>",
 			"mobileCopy": "<p>At Droga5, a creative agency, I did client work for <a href='https://glimpse.chase.com/' target='_blank'>Chase</a>, <a href='https://www.dixie.com/' target='_blank'>Dixie</a> and <a href='http://www.adweek.com/creativity/droga5s-first-work-hbo-byzantine-instagram-contest-hard-core-fans-171950/' target='_blank'>HBO </a>. I also had the opportunity to work on fun side projects like the <a href='https://www.emojireactionproject.com/' target='_blank'> Emoji Reaction Project</a>. For more info, you can download my resume <a class='resume' href='#'>here</a>.</p>"
 		},
 		"content": [
 			{
 				"client": "Chase",
 				"work": [
 					{
 						"title": "Chase Private Client",
 						"description":"Vue.js and Greensock help build this interactive tool for J.P. Morgan Chase and Co. Created the Scenario Selector page and was the only Frontend developer responsible for the implementation of the redesign. Also made the site ADA compliant.",
 						"url": "https://glimpse.chase.com/",
 						"bg_img":require('./assets/img/chasebg2.png')
 					}

 				],
 				"logo":require('./assets/img/chase.png')
 			},
 			{
 				"client": "Emoji Reaction Project",
 				"work" : [
 					{
 						"title" : "Put Your Money Where Your Emoji Is",
 						"description": "Created the landing page for this in house Chrome Extension. Using Mongoose and cron jobs, I also assisted with building the charity database.",
 						"url" : "https://www.emojireactionproject.com/",
 						"bg_img":require('./assets/img/emojibg.png')
 					}
 				],
 				"logo":require('./assets/img/emoji.png')
 			},
 			{
 				"client": "HBO",
 				"work" : [
 					{
 						"title" : "Into HBO",
 						"description": "Using PHP, I made a script that would scrape each Instagram page within the campaign and would report back any downed pages. Working on this project propelled me from intern to full-time.",
 						"url" : "http://www.adweek.com/creativity/droga5s-first-work-hbo-byzantine-instagram-contest-hard-core-fans-171950/",
 						"bg_img":require('./assets/img/hbobg.png')
 					}
 				],
 				"logo":require('./assets/img/hbo.png')
 			},
 			{
 				"client": "Dixie",
 				"work": [
 					{
 						"title" : "Dixie.com",
 						"description": "Managed, updated, and inserted new content. Turned compiled code into components within Sitecore.",
 						"url":"https://www.dixie.com/",
 						"bg_img":require('./assets/img/dixiebg.png')
 					}
 				],
 				"logo":require('./assets/img/dixie.png')
 			},
 			{
 				"client": "Dixie To Go",
 				"work": [
 					{
 						"title" : "Dixie + Project Runway",
 						"description": "Dixie teamed with Project Runway to create a unique challenge during an October 5 episode. I was solely responsible for the development of this quick turnaround project.",
 						"url":"https://www.dixie.com/cupforcrushingit",
 						"bg_img":require('./assets/img/dixietogobg3.png')
 					}
 				],
 				"logo":require('./assets/img/dixietogo.png')
 			}
 		],
 		"mobile": true,
 		"landingContent":{
 			"title": "Click one of the clients below to learn more!"
 		}
 	},
 	{
 		"navTitle": "School",
 		"coordinates": [-86.43232250827894 , 35.946471257683214],
 		"jumpToZoom": [6],
 		"content": [
 			{
 				"college": "University of Kentucky"
 			}
 		],
 		"mobile": true,
 		"landingContent":{
 			"kentucky": {
 				"coordinates": [-84.53262917008178 , 38.032365280785115],
 				"zoom" : [12]
 			},
 			"circus": {
 				"coordinates": [-84.36548680914282 , 33.81318444714475],
 				"zoom": [16]
 			}
 		},
 		"locationContent": {
 			"copy": '<p>Graduated from the <a href="#" class="university-of-kentucky">University of Kentucky</a> in Lexington, KY.<br> <br> Learned front end development at the <a href="#" class="creative-circus">Creative Circus</a> in Atlanta, GA.</ p>',
 			"mobileCopy":'<div>Graduated from the <a href="https://www.instagram.com/explore/locations/213737144/university-of-kentucky/" target="_blank" class="university-of-kentucky">University of Kentucky</a> in Lexington, KY.<br> <br> Learned front end development at the <a href="https://www.instagram.com/explore/locations/216841940/the-creative-circus/" class="creative-circus" target="_blank">Creative Circus</a> in Atlanta, GA.</ div>'
 		}
 	},
 	// {
 	// 	"navTitle": "Contact",
 	// 	"coordinates": [-80.35177116788755 , 27.62381890671321],
 	// 	"jumpToZoom": [15],
 	// 	"content":[
 	// 		"email": "bfmcgo2@gmail.com",
 	// 	],
 	// 	"mobile": true,
 	// 	"landingContent":{
	 // 		"title": "Click one of the clients below to learn more!"	
 	// 	}
 	// },
 	
];

export default navigation;


// WEBPACK FOOTER //
// ./src/navigation.js